import { toQueryString } from "../toQueryString";

const BASE_PATH = "/internal_api";

export const absolutePath = (
  path: string,
  params = {},
  queryStringOptions = {},
) => `${BASE_PATH}/${path}?${toQueryString(params, queryStringOptions)}`;

export const absolutePathWithArrayIndices = (
  path: string,
  params = {},
  queryStringOptions = {},
) =>
  `${BASE_PATH}/${path}?${toQueryString(params, {
    ...queryStringOptions,
    arrayFormat: "indices",
  })}`;
